(function() {
  function initSwatchHover() {
    document.querySelectorAll('.grid-product').forEach(function(card) {
      var mainImg = card.querySelector('.grid-product__image-mask img:not(.grid-product__secondary-image img)');
      if (!mainImg) mainImg = card.querySelector('.grid-product__image-mask .grid__image-ratio img, .grid-product__image-mask .image-wrap img');
      if (!mainImg) return;

      var secondaryImageEl = card.querySelector('.grid-product__secondary-image');
      var originalSrc = mainImg.src;
      var originalSrcset = mainImg.srcset || '';

      card.querySelectorAll('.color-swatch[data-variant-image]').forEach(function(swatch) {
        var variantImg = swatch.getAttribute('data-variant-image');
        if (!variantImg) return;

        swatch.addEventListener('mouseenter', function() {
          // Hide the secondary hover image so it doesn't cover ours
          if (secondaryImageEl) secondaryImageEl.style.opacity = '0';
          if (secondaryImageEl) secondaryImageEl.style.display = 'none';
          mainImg.src = variantImg;
          mainImg.srcset = '';
        });

        swatch.addEventListener('mouseleave', function() {
          // Restore secondary hover image
          if (secondaryImageEl) secondaryImageEl.style.opacity = '';
          if (secondaryImageEl) secondaryImageEl.style.display = '';
          mainImg.src = originalSrc;
          mainImg.srcset = originalSrcset;
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatchHover);
  } else {
    initSwatchHover();
  }

  document.addEventListener('collection:reloaded', initSwatchHover);
})();